import { ref, onMounted, onBeforeUnmount } from 'vue';

export function useHoverSupport() {
    const canHover = ref(true);
    let mq: MediaQueryList;

    const update = () => {
        canHover.value = mq.matches;
    };

    onMounted(() => {
        mq = window.matchMedia('(hover: hover)');
        update();
        mq.addEventListener('change', update);
    });

    onBeforeUnmount(() => {
        mq?.removeEventListener('change', update);
    });

    return { canHover };
}
